<template>
    <tr>
        <!-- <td><router-link :to="'/product-detail' + product_link">{{ product }}</router-link></td> -->
        <td>
            {{ displayDate }} ({{ displayTime }})
            <div v-if="savedorderdata.purchaseorder != ''">{{ savedorderdata.purchaseorder }}</div>
        </td>
        <td></td>
        <td></td>
        <!-- <td><router-link to="/order-parts" class="btn btn-xs btn-primary">Add to Order</router-link></td> -->
        <td>
            <button type="button" class="btn btn-xs btn-primary" @click="$emit('add-to-cart', savedorderdata.ordernumber)">Add to Order</button>
        </td>
        <td>
            <button type="button" class="vehicles-list__item-remove" @click="removeItem">
                <svg width="16" height="16">
                    <path d="M2,4V2h3V1h6v1h3v2H2z M13,13c0,1.1-0.9,2-2,2H5c-1.1,0-2-0.9-2-2V5h10V13z"></path>
                </svg>
            </button>
        </td>
    </tr>
</template>

<script>
import Price from '../../../mixins/price.js';

export default {
    props: {
        savedorderdata: {
            type: Object,
            required: true
        },
        index: {
            type: Number,
            required: true
        }
    },
    mixins : [
      Price
    ],
    emits: ['add-to-cart', 'remove-item'],
    computed: {
        displayDate() {
            return this.savedorderdata.month + '/' + this.savedorderdata.day + '/' + this.savedorderdata.year;
        },
        displayTime() {
            let ampm ="AM";
            let hour = this.savedorderdata.hour;
            let minutes = this.savedorderdata.minute;

            if (hour > 12) {
                hour = 12;
                ampm = "PM";
            } else if (hour === '00') {
                hour = 12;
            }

            return hour + ':' + minutes + ' ' + ampm;
        }

    },
    methods: {
        removeItem() {
            this.$emit("remove-item", this.savedorderdata.ordernumber);
        }
    
    }



}
</script>